import * as React from 'react';

import { observer } from 'mobx-react';

import { Button } from '@estee/elc-buttons';

import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';
import { classes, submitButtonClassNames, submitButtonWrapperClassNames } from '~utils/Classes';
import { IamForms, useConfig } from '~utils/hooks/config';
import { useTranslation } from '~utils/hooks/translations';
import { DynamicForm } from '~views/common/DynamicForm';
import { MessagePanel } from '~views/common/MessagePanel';

const rootClassName = classes('iam-guest-checkout');

// i.e. guest-checkout sign-in form
export const GuestCheckoutForm = observer(() => {
    const guestCheckoutFormViewController = diContainer.get(
        serviceNames.guestCheckoutFormViewController
    );

    const { loadingLabel, continueCheckoutLabel } = useTranslation();

    const {
        fieldsValidations: validations = {},
        schema = {
            sections: []
        }
    } = useConfig(IamForms.guestCheckout);

    const {
        data: { formStore, errorMessages },
        submitButtonClicked
    } = guestCheckoutFormViewController;
    const { isSubmitting } = formStore;

    return (
        <div className={rootClassName}>
            <MessagePanel messages={errorMessages} />
            <DynamicForm
                name="guestCheckoutForm"
                formSchema={schema}
                validations={validations}
                formStore={formStore}
                submit={submitButtonClicked}
            />
            <div className={submitButtonWrapperClassNames}>
                <Button
                    type="submit"
                    className={submitButtonClassNames}
                    disabled={isSubmitting}
                    onClick={submitButtonClicked}
                >
                    {isSubmitting ? loadingLabel : continueCheckoutLabel}
                </Button>
            </div>
        </div>
    );
});
